import TabPanel from "../tabs/tab-panel.vue";
export default TabPanel;
